import Modalbox from '../utils/_modal-box'

export default function VideoModal () {
  const modalBox = new Modalbox('.open-video-modal')
}
